export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8301.058fae9b.jpg";